// 主人公の普段の致命を模型で（2026-11-04）。崩れて膝をついたボスへ、主人公（細剣）が入れる一撃。
//   作者（11-03）「今のは溜めて踏み込んで刺す動きになっているけど、刺してから引き抜く動きにしてほしい」。
//   過去の作者の言葉（10-12）「引き抜く時にえぐりながら引くようにしないと、すっと刺してスッと引いてるように見える」。
//   now＝配布版の execute（public/sprites/lunaire-doll の execute を読み取った拍：0〜0.47秒 剣を頭の上へ弓のように引く溜め・
//     0.47〜0.57秒 足を大きく開いて腰を落とし突き込む・当たり 540ms・0.9秒までそのまま・そこで立ちへ戻る＝抜く動きが無い）。
//   pull / pullStep＝新しい案：短い引き→刺す（当たり 230ms）→止め 0.1秒→押し込んでえぐる→引き抜く→残心。溜めと踏み込みは主役にしない。
//     pull＝前の足を残し、重心を後ろ足へ移して踏ん張って抜く（おすすめ）／pullStep＝抜きながら半歩下がる。
//   音は今のまま（execute＋luna_exec_weight）。鳴る時刻だけ刺す瞬間に合わせる（cues に出す）。

import { humanPose } from '../body'
import { bakeTracks, type MockupMove, type Tracks, type Vec } from '../core'

/** 拍（ms）。now は配布版の値（EXECUTE の3発目の窓の頭＝2×240+60＝540・全体 3×240+180＝900）。 */
export const LUNA_EXEC_NOW_BEAT = { hitMs: 540, executeMs: 900 }
export const LUNA_EXEC_PULL_BEAT = { drawMs: 150, hitMs: 230, freezeMs: 100, pushEndMs: 420, gougeEndMs: 560, pullOutMs: 640, followMs: 740, settleMs: 1050, executeMs: 1050 }
const NB = LUNA_EXEC_NOW_BEAT, PB = LUNA_EXEC_PULL_BEAT
const DUR = 1500
/** 崩れたボスの位置（模型の単位・主人公の原点から） */
const TARGET_AT = 128
/** 崩れたボスの胸＝当たる所（[前の端, 奥の端, 上, 下]・rx と一緒に動かない） */
const TARGET_BOX: [number, number, number, number] = [TARGET_AT - 36, TARGET_AT + 14, -134, -74]

const STAND = { px: 0, py: -73, lean: 4, tw: 0, ht: 0, aF: 70, bF: 40, sF: 20, aB: 96, bB: 100, sB: 0, fF: [8, 0] as Vec, fB: [-8, 0] as Vec }
type K = Parameters<typeof humanPose>[0]
const build = (v: Record<string, number | Vec>) => humanPose({ ...STAND, ...v } as K)

/** 配布版：剣を頭の上へ弓のように引いて溜め、足を大きく開いて腰を落とし、一気に突き込む。抜く動きは無く、そのまま立ちへ戻る。 */
const NOW: Tracks = {
  px: [[0, 0], [170, 4, 'io'], [310, 2, 'io'], [470, 0, 'io'], [570, 14, 'in'], [900, 14], [1020, 0, 'io']],
  py: [[0, -73], [170, -71, 'io'], [310, -66, 'io'], [470, -64, 'io'], [570, -50, 'in'], [900, -50], [1020, -73, 'io']],
  lean: [[0, 4], [170, -4, 'io'], [310, -6, 'io'], [470, -6], [570, 26, 'in'], [900, 26], [1020, 4, 'io']],
  tw: [[0, 0], [310, -30, 'io'], [470, -34], [570, 30, 'in'], [900, 30], [1020, 0, 'io']],
  aF: [[0, 70], [170, -120, 'io'], [310, -140, 'io'], [470, -142], [570, -14, 'in'], [900, -14], [1020, 70, 'io']],
  bF: [[0, 40], [170, -40, 'io'], [310, -20, 'io'], [470, -18], [570, -12, 'in'], [900, -12], [1020, 40, 'io']],
  sF: [[0, 20], [170, 8, 'io'], [310, 10, 'io'], [470, 12], [570, -4, 'in'], [900, -4], [1020, 20, 'io']],
  aB: [[0, 96], [170, 10, 'io'], [310, 0, 'io'], [470, -2], [570, 160, 'in'], [900, 160], [1020, 96, 'io']],
  bB: [[0, 100], [170, 4, 'io'], [310, -6, 'io'], [470, -6], [570, 150, 'in'], [900, 150], [1020, 100, 'io']],
  fF: [[0, [8, 0]], [170, [14, 0], 'io'], [470, [14, 0]], [520, [32, -6], 'in'], [570, [48, 0], 'out'], [900, [48, 0]], [960, [30, -5], 'io'], [1020, [8, 0], 'io']],
  fB: [[0, [-8, 0]], [470, [-10, 0]], [570, [-30, 0], 'in'], [900, [-30, 0]], [1020, [-8, 0], 'io']],
}

/** 新しい案の前半（刺す・止め・押し込み・えぐり）。後半（引き抜き・残心）は2案で分ける。 */
const STAB: Tracks = {
  px: [[0, 0], [PB.drawMs, -4, 'io'], [PB.hitMs, 6, 'in'], [PB.hitMs + PB.freezeMs, 6], [PB.pushEndMs, 12, 'out'], [PB.gougeEndMs, 12]],
  py: [[0, -73], [PB.drawMs, -70, 'io'], [PB.hitMs, -68, 'in'], [PB.hitMs + PB.freezeMs, -68], [PB.pushEndMs, -62, 'out'], [PB.gougeEndMs, -61]],
  lean: [[0, 4], [PB.drawMs, 0, 'io'], [PB.hitMs, 12, 'in'], [PB.hitMs + PB.freezeMs, 12], [PB.pushEndMs, 20, 'out'], [PB.gougeEndMs, 20]],
  tw: [[0, 0], [PB.drawMs, -20, 'io'], [PB.hitMs, 24, 'in'], [PB.hitMs + PB.freezeMs, 24], [PB.pushEndMs, 26], [480, 40, 'io'], [PB.gougeEndMs, 30, 'io']],
  // 腕＝引いて（肘を後ろ・剣は前を向いたまま腰の高さ）→まっすぐ突く→押し込む→手首をこねる（手を上下に回し、切っ先は中で逆へ動く）
  aF: [[0, 70], [PB.drawMs, 150, 'io'], [PB.hitMs, 2, 'in'], [PB.hitMs + PB.freezeMs, 2], [PB.pushEndMs, 4, 'out'], [480, -10, 'io'], [PB.gougeEndMs, 12, 'io']],
  bF: [[0, 40], [PB.drawMs, 0, 'io'], [PB.hitMs, -6, 'in'], [PB.hitMs + PB.freezeMs, -6], [PB.pushEndMs, -2, 'out'], [480, -10, 'io'], [PB.gougeEndMs, 4, 'io']],
  sF: [[0, 20], [PB.drawMs, -6, 'io'], [PB.hitMs, 2, 'in'], [PB.hitMs + PB.freezeMs, 2], [PB.pushEndMs, 2, 'out'], [480, 16, 'io'], [PB.gougeEndMs, -10, 'io']],
  aB: [[0, 96], [PB.drawMs, 30, 'io'], [PB.hitMs, 150, 'in'], [PB.gougeEndMs, 150]],
  bB: [[0, 100], [PB.drawMs, 20, 'io'], [PB.hitMs, 130, 'in'], [PB.gougeEndMs, 130]],
  fF: [[0, [8, 0]], [PB.drawMs, [8, 0]], [190, [20, -6], 'in'], [PB.hitMs, [28, 0], 'out'], [PB.gougeEndMs, [28, 0]]],
  fB: [[0, [-8, 0]], [PB.hitMs, [-4, 0]], [PB.gougeEndMs, [-4, 0]]],
}

const join = (a: Tracks, b: Tracks): Tracks => Object.fromEntries(Object.keys(a).map(k => [k, [...a[k]!, ...(b[k] ?? [])]]))
const END: Record<string, number | Vec> = { px: 0, py: -73, lean: 4, tw: 0, aF: 70, bF: 40, sF: 20, aB: 96, bB: 100 }
const tail = (rest: Partial<Record<string, number | Vec>>, endPx: number): Tracks => ({
  px: [[PB.settleMs, (rest.px as number) ?? 0, 'io'], [1300, endPx, 'io']],
  py: [[PB.settleMs, -72, 'io'], [1300, END.py as number, 'io']],
  lean: [[PB.settleMs, 6, 'io'], [1300, 4, 'io']],
  tw: [[PB.settleMs, 0, 'io']],
  aF: [[PB.settleMs, 74, 'io'], [1300, 70, 'io']], bF: [[PB.settleMs, 54, 'io'], [1300, 40, 'io']], sF: [[PB.settleMs, 30, 'io'], [1300, 20, 'io']],
  aB: [[PB.settleMs, 96, 'io']], bB: [[PB.settleMs, 100, 'io']],
})

/** 踏ん張って抜く（おすすめ）：前の足は残したまま、重心を後ろ足へ移し、上体を起こしながら肘を一気に後ろへ引く。 */
const PULL: Tracks = join(STAB, {
  px: [[PB.pullOutMs, 4, 'in'], [PB.followMs, 2, 'out'], ...tail({ px: 4 }, 4).px!],
  py: [[PB.pullOutMs, -68, 'in'], [PB.followMs, -70, 'out'], ...tail({}, 4).py!],
  lean: [[PB.pullOutMs, -6, 'in'], [PB.followMs, -10, 'out'], ...tail({}, 4).lean!],
  tw: [[PB.pullOutMs, -28, 'in'], [PB.followMs, -34, 'out'], ...tail({}, 4).tw!],
  aF: [[PB.pullOutMs, 160, 'in'], [PB.followMs, 150, 'out'], ...tail({}, 4).aF!],
  bF: [[PB.pullOutMs, -4, 'in'], [PB.followMs, -8, 'out'], ...tail({}, 4).bF!],
  sF: [[PB.pullOutMs, -10, 'in'], [PB.followMs, -14, 'out'], ...tail({}, 4).sF!],
  aB: [[PB.pullOutMs, 40, 'in'], [PB.followMs, 60, 'out'], ...tail({}, 4).aB!],
  bB: [[PB.pullOutMs, 30, 'in'], [PB.followMs, 50, 'out'], ...tail({}, 4).bB!],
  fF: [[PB.settleMs, [28, 0]], [1180, [18, -5], 'io'], [1300, [12, 0], 'io']],
  fB: [[PB.pullOutMs, [-8, 0], 'in'], [PB.settleMs, [-8, 0]], [1300, [-4, 0], 'io']],
})

/** 抜きながら半歩下がる：前の足を引き寄せ、体ごと後ろへ下がって剣を抜く（上体はあまり反らない）。 */
const PULL_STEP: Tracks = join(STAB, {
  px: [[PB.pullOutMs, -12, 'in'], [PB.followMs, -18, 'out'], ...tail({ px: -18 }, -18).px!],
  py: [[PB.pullOutMs, -68, 'in'], [PB.followMs, -71, 'out'], ...tail({}, -18).py!],
  lean: [[PB.pullOutMs, 4, 'in'], [PB.followMs, 0, 'out'], ...tail({}, -18).lean!],
  tw: [[PB.pullOutMs, -20, 'in'], [PB.followMs, -26, 'out'], ...tail({}, -18).tw!],
  aF: [[PB.pullOutMs, 140, 'in'], [PB.followMs, 142, 'out'], ...tail({}, -18).aF!],
  bF: [[PB.pullOutMs, -2, 'in'], [PB.followMs, -6, 'out'], ...tail({}, -18).bF!],
  sF: [[PB.pullOutMs, -8, 'in'], [PB.followMs, -12, 'out'], ...tail({}, -18).sF!],
  aB: [[PB.pullOutMs, 40, 'in'], [PB.followMs, 60, 'out'], ...tail({}, -18).aB!],
  bB: [[PB.pullOutMs, 30, 'in'], [PB.followMs, 50, 'out'], ...tail({}, -18).bB!],
  fF: [[600, [16, -7], 'in'], [PB.followMs, [-6, 0], 'out'], [1300, [-10, 0], 'io']],
  fB: [[PB.pullOutMs, [-20, 0], 'in'], [PB.followMs, [-24, 0], 'out'], [1300, [-26, 0], 'io']],
})

const bump = (t: number, at: number, rise: number, fall: number): number =>
  t < at ? Math.max(0, 1 - (at - t) / rise) ** 2 : Math.max(0, 1 - (t - at) / fall)
/** 今：刺された瞬間に後ろへ押されるだけ。 */
const targetNow = (t: number) => ({ dx: 4 * bump(t, NB.hitMs + 20, 30, 300), lean: -7 * bump(t, NB.hitMs + 20, 30, 360) })
/** 新：刺されて押され（押し込みで更に）、えぐりで震え、抜かれる瞬間に剣に引かれて主人公の側へ前のめりになる。 */
const targetPull = (t: number) => {
  const shove = bump(t, PB.hitMs + 10, 30, 600) * 0.7 + bump(t, PB.pushEndMs, 120, 200) * 0.5
  const quiver = t > PB.pushEndMs && t < PB.gougeEndMs ? Math.sin((t - PB.pushEndMs) / 18) * 1.6 : 0
  const yank = bump(t, PB.pullOutMs - 20, 60, 420)
  return { dx: 4 * shove - 5 * yank, lean: -8 * shove + quiver + 12 * yank }
}

const NOW_SOURCE = '配布版の普段の致命（execute）の拍：溜め 0〜0.47秒・踏み込みと突き 0.47〜0.57秒・当たり 0.54秒・0.9秒で立ちへ戻る。音（execute＋低い芯）は当たりで鳴る（帯の黄色）。'
const PULL_SOURCE = '新しい案：引き 0.15秒→刺す（当たり 0.23秒・止め 0.1秒）→押し込み→えぐり（0.42〜0.56秒）→引き抜き（0.56〜0.64秒）→残心。音は今の2つを刺す瞬間に（帯の黄色）。'

const base = {
  boss: '主人公', body: 'human-rapier-skirt', durMs: DUR, scale: 1.05, baseX: 120, heroAt: TARGET_AT,
  activeMs: 70, box: TARGET_BOX, paths: ['sF'], fadeOutMs: 200, interp: 'linear' as const,
  target: 'downed' as const, faceRight: true,
}

export const LUNA_EXEC_NOW_MOCKUP: MockupMove = {
  ...base, id: 'luna-exec-now', label: '普段の致命・今（溜めて踏み込んで刺す）',
  keys: bakeTracks(NOW, DUR, build),
  phases: [
    { from: 0, to: 470, label: '溜め：剣を頭の上へ大きく引く', kind: 'tell' },
    { from: 470, to: 610, label: '踏み込んで刺す', kind: 'hit' },
    { from: 610, to: NB.executeMs, label: '刺したまま止まる', kind: 'rest' },
    { from: NB.executeMs, to: DUR, label: '立ちへ戻る（抜く動きが無い）', kind: 'rest' },
  ],
  hits: [NB.hitMs], cues: [{ at: NB.hitMs, ms: 60 }], targetFn: targetNow, source: NOW_SOURCE,
}

const pullPhases = (pullLabel: string): MockupMove['phases'] => [
  { from: 0, to: PB.drawMs, label: '引き（短く・溜めは主役にしない）', kind: 'tell' },
  { from: PB.drawMs, to: PB.hitMs + PB.freezeMs, label: '刺す（刺した瞬間 0.1秒止まる）', kind: 'hit' },
  { from: PB.hitMs + PB.freezeMs, to: PB.gougeEndMs, label: '押し込んで、えぐる', kind: 'tell' },
  { from: PB.gougeEndMs, to: PB.followMs, label: pullLabel, kind: 'hit' },
  { from: PB.followMs, to: DUR, label: '残心・構えへ戻る', kind: 'rest' },
]

export const LUNA_EXEC_PULL_MOCKUP: MockupMove = {
  ...base, id: 'luna-exec-pull', label: '普段の致命・新 A（刺す→えぐって、踏ん張って引き抜く）',
  keys: bakeTracks(PULL, DUR, build), phases: pullPhases('引き抜く：前の足は残し、重心を後ろ足へ'),
  hits: [PB.hitMs], cues: [{ at: PB.hitMs, ms: 60 }], targetFn: targetPull, source: PULL_SOURCE,
}

export const LUNA_EXEC_PULL_STEP_MOCKUP: MockupMove = {
  ...base, id: 'luna-exec-pull-step', label: '普段の致命・新 B（刺す→えぐって、下がりながら引き抜く）',
  keys: bakeTracks(PULL_STEP, DUR, build), phases: pullPhases('引き抜く：半歩下がりながら'),
  hits: [PB.hitMs], cues: [{ at: PB.hitMs, ms: 60 }], targetFn: targetPull, source: PULL_SOURCE,
}

export const LUNA_EXEC_MOCKUPS = [LUNA_EXEC_NOW_MOCKUP, LUNA_EXEC_PULL_MOCKUP, LUNA_EXEC_PULL_STEP_MOCKUP]
